import * as z from "zod";

export const signInPrintNodeAccount = {
  name: "signInPrintNodeAccount" as const,
  input: z.object({ email: z.string().email(), password: z.string().min(1) }),
  output: z.object({ success: z.boolean(), message: z.string().optional() }),
};
